import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import SignupController from './signup.controller';
import SignupSuccess from './signup-success';
import { Button as AntButton, Input as AntInput } from 'antd';
import { MailOutlined, LockOutlined, UserOutlined, PhoneOutlined, HomeOutlined } from '@ant-design/icons';
import styles from './styles/signup.module.scss';

/**
 * @extends SignupController
 * @extends Component
 */
class Signup extends Inherit(SignupController, Component) {
    state = {
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        phoneNumber: '',
        password: '',
        loading: false,
        error: false,
        showSuccessScreen: false
    };

    render() {
        const { firstName, lastName, email, companyName, phoneNumber, password, error, loading, showSuccessScreen } = this.state;

        // Check if all required fields (except phone) are filled
        const isFormValid = firstName && lastName && email && companyName && password;

        if (showSuccessScreen) {
            return <SignupSuccess />;
        }

        return (
            <div className={styles.signupContainer}>
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo-color.png" alt="Clockout Logo" className={styles.logo} />
                    </div>
                    
                    <div className={styles.contentWrapper}>
                        <div className={styles.headerSection}>
                            <h1 className={styles.title}>Get started with Clockout</h1>
                            <p className={styles.subtitle}>
                                Create your account to get started in your Earned Wage Access (EWA) service set up.
                            </p>
                        </div>

                        <div className={styles.imageSection}>
                            <img src="/phone-ux.png" alt="Clockout App Preview" className={styles.phoneImage} />
                        </div>
                    </div>
                </div>

                <div className={styles.rightSection}>
                    <div className={styles.formHeader}>
                        <span className={styles.alreadyHaveAccount}>Already have an account?</span>
                        <AntButton 
                            type="text" 
                            onClick={() => this.navigateLogin()}
                            className={styles.signInButton}
                        >
                            Sign in
                        </AntButton>
                    </div>

                    <div className={styles.signupCard}>
                        <h2 className={styles.formTitle}>Create an account</h2>

                        <div className={styles.nameRow}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>First name</label>
                                <AntInput
                                    size="large"
                                    value={firstName || ''}
                                    onChange={(e) => this.setFirstName(e.target.value)}
                                    placeholder="name"
                                    status={error ? 'error' : ''}
                                    className={styles.input}
                                />
                            </div>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Last name</label>
                                <AntInput
                                    size="large"
                                    value={lastName || ''}
                                    onChange={(e) => this.setLastName(e.target.value)}
                                    placeholder="name"
                                    status={error ? 'error' : ''}
                                    className={styles.input}
                                />
                            </div>
                        </div>

                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Email</label>
                            <AntInput
                                disabled={true}
                                size="large"
                                prefix={<MailOutlined className={styles.inputIcon} />}
                                type="email"
                                value={email || ''}
                                onChange={(e) => this.setEmail(e.target.value)}
                                placeholder="email"
                                status={error ? 'error' : ''}
                                className={styles.input}
                            />
                        </div>

                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Company name</label>
                            <AntInput
                                disabled={true}
                                size="large"
                                prefix={<HomeOutlined className={styles.inputIcon} />}
                                value={companyName || ''}
                                onChange={(e) => this.setCompanyName(e.target.value)}
                                placeholder="company name"
                                status={error ? 'error' : ''}
                                className={styles.input}
                            />
                        </div>

                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Phone number</label>
                            <AntInput
                                size="large"
                                prefix={<PhoneOutlined className={styles.inputIcon} />}
                                addonBefore="+1"
                                value={phoneNumber || ''}
                                onChange={(e) => this.setPhoneNumber(e.target.value)}
                                placeholder="phone number"
                                status={error ? 'error' : ''}
                                className={styles.input}
                            />
                        </div>

                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Password</label>
                            <AntInput.Password
                                size="large"
                                prefix={<LockOutlined className={styles.inputIcon} />}
                                value={password || ''}
                                onChange={(e) => this.setPassword(e.target.value)}
                                placeholder="password"
                                status={error ? 'error' : ''}
                                className={styles.input}
                            />
                        </div>

                        <AntButton
                            type="primary"
                            size="large"
                            loading={loading}
                            onClick={() => this.createAccount()}
                            className={`${styles.continueButton} ${isFormValid ? styles.continueButtonActive : ''}`}
                            disabled={!isFormValid}
                            block
                        >
                            Continue
                        </AntButton>
                    </div>
                </div>

                <div className={styles.footer}>
                    <span className={styles.copyright}>Copyright © 2025 Clockout Financial Inc.</span>
                    <div className={styles.footerLinks}>
                        <a href="/terms" className={styles.footerLink}>Terms and Conditions</a>
                        <a href="/privacy" className={styles.footerLink}>Privacy Policy</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withHooks(Signup);

